import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './index';
import UserHome from './userhome';
import UserSetting from './userSetting';
import ForgetPassword from './forgetPassword';
import Scanner from './scanner';
import Redeem from './redeem';
import UploadReceipt from './uploadReceipt';
import Records from './records';
import store from 'store-js';
import { useCookieState } from 'ahooks';
// import PrivateRoute from "../components/_privateRoute";
// import { checkNavigationType } from "../utilities/Utils";

// Temporary — remove after verifying Sentry error tracking
function ErrorButton() {
    return (
        <button
            type="button"
            style={{ position: 'fixed', bottom: 16, right: 16, zIndex: 9999 }}
            onClick={() => {
                throw new Error('This is your first error!');
            }}
        >
            Break the world
        </button>
    );
}

export default function App({ config }) {
    const [token, setToken] = useCookieState('access_token', { secure: true, sameSite: 'strict' });
    // console.log(checkNavigationType());
    // if(checkNavigationType() ===1)

    return (
        <BrowserRouter>
            {/* <ErrorButton /> */}
            <Routes>
                <Route path="/" element={<Home config={config} />} />
                <Route
                    path="/userhome"
                    element={
                        // <PrivateRoute token={token}>
                        <UserHome config={config} />
                        // </PrivateRoute>
                    }
                />
                <Route path="/forget_password" element={<ForgetPassword config={config} />} />
                <Route path="/userSetting" element={<UserSetting config={config} />} />
                <Route
                    path="/scanner"
                    element={
                        // token ?
                        <Scanner config={config} />
                        //  : <Navigate to="/" replace />
                    }
                />
                <Route
                    path="/redeem"
                    element={
                        // token ?
                        <Redeem config={config} />
                        //  : <Navigate to="/" replace />
                    }
                />
                <Route
                    path="/records"
                    element={
                        // token ?
                        <Records config={config} />
                        //  : <Navigate to="/" replace />
                    }
                />
                <Route
                    path="/uploadReceipt"
                    element={
                        // token ?
                        <UploadReceipt config={config} />
                        //  : <Navigate to="/" replace />
                    }
                />
                <Route path="*" element={token ? <Navigate to="/userhome" /> : <Navigate to="/" />} />
            </Routes>
        </BrowserRouter>
    );
}
